// Vendors
import $ from 'jquery';
import Player from '@vimeo/player';
import Plyr from 'plyr';

if ($('.card-media-popup').length) {
  // Move modal from .page-content to body.
  $('#media-popup-modal').appendTo('body').addClass('modal--moved');
  // If there are multiple modals on the page, remove others
  $('#media-popup-modal:not(.modal--moved)').remove();

  if (
    $('.card-media-popup__image[data-hs-id]').length &&
    !hubspotScriptExists()
  ) {
    asyncLoadHubspot();
  }

  // Open modal on click.
  $(
    '.card-media-popup__image[data-media-type="video"], .card-media-popup__action[data-media-type="video"]'
  ).on('click', (event) => {
    if (!event) return;
    event.preventDefault();

    const $this = $(event.currentTarget);
    const $modalVideoOuter = $('#media-popup-modal .media-popup-modal__video');
    const $modal = $('#media-popup-modal.modal');
    const modalSize = {
      video: 'xl',
      form: 'md'
    };
    const $modalForm = $('#media-popup-modal__form');
    const hubspotFormId = $this.data('hs-id');
    const videoId = $this.data('video-id');
    const videoPlatform = $this.data('video-source');
    const userEmail = $this.data('video-log-hs');
    const eventName = $this.data('video-event-name');
    const videoPlatforms = {
      youtube: `https://www.youtube.com/embed/${videoId}?modestbranding=1&autohide=1&showinfo=0&autoplay=1&rel=0&ytp-pause-overlay=0&fs=0&iv_load_policy=3&playsinline=1`,
      vimeo: `https://player.vimeo.com/video/${videoId}?badge=0&byline=0&portrait=0&title=0&autoplay=1&autopause=0&playsinline=1`
    };
    // Functionality pulled from video-modal.js and put in a function to handle HubSpot logging. Possible TODO, add this to helper file.
    const logHubspotProgress = (playerData) => {
        if (playerData.percent >= 0.25) {
          if (window._hsq) {
            _hsq.push(['identify', { email: userEmail }]);
            _hsq.push([
              'trackCustomBehavioralEvent',
              {
                name: eventName,
                properties: {
                  video_source: videoPlatform,
                  video_id: videoId
                }
              }
            ]);
            _hsq.push([
              'trackEvent',
              { id: `Watched ${videoPlatform} video: ${videoId}` }
            ]);
          }
  
          // Kill listener
          player.off('timeupdate', logHubspotProgress);
        }
    };

    // Bail if video is not youtube or Vimeo.
    if (!videoPlatforms[videoPlatform]) return;

    // Prep video container to be injected.
    let $videoContainer;
    if ('vimeo' === videoPlatform) {
      $videoContainer = $(
        `<iframe width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen allow="autoplay"></iframe>`
      );
      $videoContainer.parent().addClass('u--embed-responsive');
    } else {
      $videoContainer = $(
        `<div data-plyr-provider="${videoPlatform}" data-plyr-embed-id="${videoId}"></div>`
      );
    }

    // And add video container to modal.
    $modalVideoOuter.html('').append($videoContainer);

    // Set iframe source, if vimeo.
    if ('vimeo' === videoPlatform) {
      $videoContainer.attr('src', videoPlatforms[videoPlatform]);
    }

    // Use different player, depending on platform.
    const player =
      videoPlatform === 'vimeo'
        ? new Player($modalVideoOuter.children('iframe'))
        : new Plyr($modalVideoOuter.children('[data-plyr-embed-id]'), {
            debug: false,
            hideControls: false,
            controls: [],
            loadSprite: false,
            autoplay: true,
            muted: false,
            volume: 100,
            loop: { active: false }
          });

    // (As a fallback, since videos should autoplay after load.)
    player.play();

    //seperate event listener for the watched_video event
    if (videoPlatform === 'vimeo') {
      if (userEmail && eventName) {
        //if two HS related fields are present, push the watched video event to HS if its vimeo
          player.on('timeupdate', logHubspotProgress);
      }
    };

    // Video duration listener.
    player.on('timeupdate', (playerData) => {
      if (videoPlatform === 'vimeo') {
        if (playerData.percent >= 1 && hubspotFormId) {
          killVideoInjectForm();
        }
      } else {
        if (player.currentTime >= player.duration && hubspotFormId) {
          killVideoInjectForm();
        }
      }
    });

    // Toggle some document classes.
    $('html, body').addClass('video-modal-is-visible');

    // Toggle some modal classes.
    $modal
      .removeClass(`modal--${modalSize.form}`)
      .addClass(`modal--${modalSize.form} modal--visible`);

    // To make sure the click handler below doesn't get confused.
    $('.media-popup-modal__dialog').on('click', (event) =>
      event.stopPropagation()
    );

    // Close event handler, clean up modal.
    $('#media-popup-modal .modal__close, #media-popup-modal.modal--visible').on(
      'click',
      () => {
        // Toggle some document classes.
        $('html, body').removeClass('video-modal-is-visible');

        // Toggle some modal classes.
        $modal.removeClass(
          `modal--visible modal--form-visible modal--${modalSize.form}`
        );

        // Clean out form container and hide.
        $modalForm.html('').hide();

        // Kill and rm video.
        player.destroy();
        $('#media-popup-modal .media-popup-modal__video')
          .html('')
          .parent()
          .show();
      }
    );

    // Keep within scope, as it needs to be able to access 'player'.
    function killVideoInjectForm() {
      player.destroy();

      injectForm('#media-popup-modal__form', hubspotFormId, () => {
        // Toggle some modal classes.
        $modal
          .removeClass(`modal--${modalSize.video}`)
          .addClass(`modal--form-visible modal--${modalSize.form}`);

        // Remove video content from modal.
        $modalVideoOuter.html('').parent().hide();

        // Show form.
        $modalForm.show();
      });
    }
  });

  // Helpers
  function hubspotScriptExists() {
    const scriptURL = '//js.hsforms.net/forms/v2.js';
    const scriptTags = document.getElementsByTagName('script');

    for (let i = scriptTags.length; --i; ) {
      if (scriptTags[i].src.includes(scriptURL)) return true;
    }

    return false;
  }

  function asyncLoadHubspot() {
    const scriptURL = '//js.hsforms.net/forms/v2.js';
    const scriptTag = document.createElement('script');
    scriptTag.src = scriptURL;
    document.body.appendChild(scriptTag);
  }

  function injectForm(target, formId, callback) {
    hbspt.forms.create({
      portalId: '3572053',
      target,
      formId,
      onFormReady: callback
    });
  }
}
